
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coming-soon-agencies",
      function () {
        return require("private-next-pages/coming-soon-agencies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coming-soon-agencies"])
      });
    }
  